import * as React from 'react';
import { IDs } from '../../../helpers/IDs';
import { WTable } from '../../../core/table/WTable';
import { filterMethodFulltext } from '../../../core/forms/helpers/filter_method_fulltext';
import { i18n } from '../../../i18n/i18n';

export interface MandantenBenutzerProps {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

export interface MandantenBenutzerState {

}

export class MandantenBenutzer extends React.Component<MandantenBenutzerProps, MandantenBenutzerState> {

    constructor(props: any) {
        super(props);
        this.state = {

        };
    }

    componentDidMount(): void {

    }

    render(): JSX.Element {
        const dataRows = this.getDataRows();
        const dataRowsRaw = this.getDataRows(true);
        const columns = this.getColumns();
        return <div className='Custom-ETA'>
            <WTable
                module={IDs.MOD_ETOOL_ADMIN}
                entity={IDs.ENT_MANDANTEN_USER}
                customClass='Custom-ETA'
                data={dataRows}
                rawData={dataRowsRaw}
                columns={columns}
                onAction={() => { }}
                pageSize={10}
                showTableHelp={true}
                showColumnsHelp={true}
                showColumnsSortBtn={true}
                showPagination={true}
                customTdProps={(state: any, rowInfo: any, column: any) => {
                    return { style: { padding: '10px 2px' } };
                }}
            />
        </div>;
    }

    getDataRows(exportRaw?: boolean): Array<any> {
        const dataRows: Array<any> = [];
        if (Array.isArray(this.props.data[IDs.ENT_MANDANTEN_USER])) {
            const map: any = {};
            this.props.data[IDs.ENT_MANDANTEN_USER].forEach((r: any) => {
                if (r.mail) {
                    if (!map[r.mail]) {
                        map[r.mail] = {};
                    }
                    if (r.registrierung) {
                        map[r.mail][r.registrierung] = 1;
                    }
                }
            });
            const mails = Object.keys(map);
            mails.sort().forEach((mail: string) => {
                const unternehmen_arr = Object.keys(map[mail]).sort();
                const untrnehmen_str = unternehmen_arr.join(`\n`);
                const untrnehmen = <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {unternehmen_arr.map((u: string) =>
                        <div style={{ marginBottom: 5 }}>{u}</div>)}
                </div>;
                if (exportRaw) {
                    dataRows.push({ mail, untrnehmen: untrnehmen_str });
                } else {
                    dataRows.push({ mail, untrnehmen, untrnehmen_str });
                }
            });
        }
        return dataRows;
    }

    getColumns(): any[] {
        const mail: string = i18n('Mandanen-Benutzer', 'sys');
        const untrnehmen: string = i18n('Untrnehmen', 'sys');
        return [
            {
                id: 'mail',
                accessor: 'mail',
                Header: mail,
                HeaderText: mail,
                type: 'text',
                filterMethod: (filter: any, row: any) => filterMethodFulltext(filter, row._original, 'mail')
            },
            {
                id: 'untrnehmen',
                accessor: 'untrnehmen',
                Header: untrnehmen,
                HeaderText: untrnehmen,
                type: 'text',
                filterMethod: (filter: any, row: any) => filterMethodFulltext(filter, row._original, 'untrnehmen_str')
            }
        ];
    }
}
